import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { NSUnitTrainConstants } from '@ruby/configs/unit-train.constants';
import { IUnitTrainFilters, IUTFiltersConfigurations, IUTFiltersExtraConfigurations } from '@ruby/modules/unit-train/models/unit-train.interface';
import { fromUTAdvanceSearch, UTAdvanceSearchActions, UTAdvanceSearchSelectors } from '@ruby/modules/unit-train/store/ut-advance-search.index';
import { EUTCalendarType } from '@ruby/shared/enums/unit-train.enums';

@Component({
  selector: 'ng-ut-monthly-results-container',
  styleUrls: ['./ut-monthly-results.container.scss'],
  templateUrl: './ut-monthly-results.container.html'
})
export class UTMonthlyResultsContainer implements OnInit {
  @Input() filters!: Partial<IUTFiltersConfigurations>;
  calendarType = EUTCalendarType.MONTHLY;
  store$: Observable<fromUTAdvanceSearch.State>;
  filtersConfigs: Partial<IUTFiltersConfigurations> = NSUnitTrainConstants.utCalendarFiltersConfigs[this.calendarType];
  filtersExtraConfigs: Partial<IUTFiltersExtraConfigurations> = { searchOnInit: true };

  constructor(private store: Store<fromUTAdvanceSearch.State>) {
    this.store$ = store.select(UTAdvanceSearchSelectors.selectUTAdvanceSearchState);
  }

  ngOnInit(): void {
    this.filtersConfigs = { ...this.filtersConfigs, ...this.filters };
  }

  /**
   * Make Advance Search
   *
   * @summary emit an event to make a search
   * @param $filters: IUnitTrainFilters
   * @return void
   */
  makeAdvanceSearch($filters: IUnitTrainFilters): void {
    this.store.dispatch(UTAdvanceSearchActions.getMonthlyEvents({ data: $filters }));
  }
}
